import { createContext, useContext, type ReactNode } from 'react';

import { buildInfo, type BuildInfo } from '#utils/build-info';

const BuildInfoContext = createContext<BuildInfo | undefined>(undefined);

interface BuildInfoProviderProps {
  children: ReactNode;
}

export function BuildInfoProvider({ children }: BuildInfoProviderProps) {
  return (
    <BuildInfoContext.Provider value={buildInfo}>
      {children}
    </BuildInfoContext.Provider>
  );
}

export function useBuildInfo() {
  const context = useContext(BuildInfoContext);
  if (context === undefined) {
    throw new Error('useBuildInfo must be used within a BuildInfoProvider');
  }

  return context;
}
